import type {FC, ReactElement} from 'react'
import {useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

const EdgeViewCleanup: FC = (): ReactElement | null => {
  const {pathname, search} = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname.startsWith('/settings')) {
      return
    }
    if (!search.includes('edge_view=')) {
      return
    }
    const params = new URLSearchParams(search)
    if (params.has('edge_view')) {
      params.delete('edge_view')
      const nextSearch = params.toString()
      navigate({pathname, search: nextSearch ? `?${nextSearch}` : ''}, {replace: true})
    }
  }, [navigate, pathname, search])

  return null
}

export default EdgeViewCleanup
